import { Box, Paragraph } from '@alto-avios/alto-ui'
import StepperCircle, { getStatus } from './StepperCircle/StepperCircle'
import { StepperProps } from './Stepper.types'
import styles from './Stepper.module.scss'

function Stepper({ steps, currentStep, onCurrentStepChange }: StepperProps) {
  // calculates the width of the line based on the number of steps
  const FULL_WIDTH_PERCENTAGE = 100

  const calcLineWidth = (stepCount: number) => (FULL_WIDTH_PERCENTAGE / stepCount) * (stepCount - 1)
  const setLineWidth = `${calcLineWidth(steps.length)}%`

  const calcCompletedLineWidth = (stepCount: number) => {
    const lineOffset = 1
    const totalLines = stepCount - lineOffset

    return (currentStep / totalLines) * FULL_WIDTH_PERCENTAGE
  }
  const setCompletedLineWidth = `${calcCompletedLineWidth(steps.length)}%`

  return (
    <div className={styles.stepperContainer}>
      <div className={styles.lineContainer} style={{ width: setLineWidth }}>
        <div className={styles.backgroundLine} />
        <div className={styles.completedLine} style={{ width: setCompletedLineWidth }} />
      </div>

      <div className={styles.stepsContainer} role="list" aria-label="stepper">
        {steps.map((step, index) => {
          const stepNumberOffset = 1
          const stepNumber = index + stepNumberOffset
          const isSelected = index === currentStep
          const isCompleted = index < currentStep
          const status = getStatus(isCompleted, isSelected)
          const { title } = step

          return (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              flexGrow={1}
              flexBasis="0"
              gap="sm"
              key={title}
              role="listitem"
              aria-label={`step ${stepNumber}`}
            >
              <StepperCircle
                editable={step.editable}
                selectStep={onCurrentStepChange}
                title={title}
                number={stepNumber}
                status={status}
              />
              <Paragraph
                size={{ base: 'xs', md: 'sm' }}
                textAlign="center"
                foregroundColor={isSelected ? 'accentPrimary' : 'accentSecondary'}
                aria-hidden
              >
                {isSelected ? <strong>{title}</strong> : title}
              </Paragraph>
            </Box>
          )
        })}
      </div>
    </div>
  )
}

export default Stepper
